export enum OptionsetVisualization {
  Automatic,
  Dropdown,
  RadioButton,
  Checkbox,
  SlideToggle,
}
